<template>
  <div class="calendar-css" :id="`calendar${index}`">
    <div class="header">
      <h1>{{current / 1000 | dateformatFilter('MMMM YYYY')}}</h1>
      <div class="right" @click="nextMonth"></div>
      <div class="left" @click="prevMonth"></div>
    </div>
    <transition name="component-fade" mode="out-in">
      <div class="month" :key="ckey">
        <div class="week" v-for="(days, midx) in monthData" :key="midx">
          <div
            class="day"
            v-for="(day, didx) in days"
            :key="didx"
            :class="{'today' : day.today, 'other': day.other}"
          >
            <div class="day-name">{{day.name}}</div>
            <div class="day-number">{{day.number}}</div>
            <div class="day-events">
              <span :class="day.color">{{day.hours}} hr</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  props: ["index", "data"],
  data() {
    return {
      today: moment().tz("America/Los_Angeles"),
      current: {},
      ckey: "",
      monthData: []
    };
  },
  watch: {
    data: function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.current = moment()
        .tz("America/Los_Angeles")
        .startOf("month");
      this.ckey = "i_" + this.current.valueOf();
      this.genData();
    },
    nextMonth: function() {
      this.current.add(1, "months");
      this.ckey = "i_" + this.current.valueOf();
      this.$emit("dateChange", this.current.valueOf());
      this.genData();
    },
    prevMonth: function() {
      this.current.subtract(1, "months");
      this.ckey = "i_" + this.current.valueOf();
      this.$emit("dateChange", this.current.valueOf());
      this.genData();
    },
    genData: function() {
      this.monthData = [];
      let wIdx = -1;
      //backFill
      let clone = this.current.clone();
      let dayOfWeek = clone.day();
      if (dayOfWeek) {
        clone.subtract(dayOfWeek + 1, "days");
        for (let i = dayOfWeek; i > 0; i--) {
          let day = clone.add(1, "days");
          if (this.isWeekend(day)) {
            wIdx++;
          }
          this.genDay(day, wIdx, "other");
        }
      }
      //currentMonth
      clone = this.current.clone();
      while (clone.month() === this.current.month()) {
        let day = clone;
        if (this.isWeekend(day)) {
          wIdx++;
        }
        this.genDay(day, wIdx);
        //add event
        const dateTime = day.format("YYYYMMDD");
        const __data = this.data["i_" + dateTime];
        if (__data) {
          const day = this.monthData[wIdx][this.monthData[wIdx].length - 1];
          day.hours = __data.hours;
          const isHistory = __data.isHistory;
          day.color = isHistory ? "yellow" : "green";
        }
        clone.add(1, "days");
      }
      // console.log('m', wIdx, this.monthData);
      //fowardFill
      clone = this.current
        .clone()
        .add(1, "months")
        .subtract(1, "days");
      dayOfWeek = clone.day();
      if (dayOfWeek !== 6) {
        for (let i = dayOfWeek; i < 6; i++) {
          let day = clone.add(1, "days");
          if (this.isWeekend(day)) {
            wIdx++;
          }
          this.genDay(day, wIdx, "other");
        }
      }
    },
    isWeekend: function(day) {
      if (day.day() === 0) {
        return true;
      }
    },
    genDay: function(day, weekIndex, other) {
      if (!this.monthData[weekIndex]) this.monthData[weekIndex] = [];
      let d = {
        name: day.format("ddd"),
        number: day.format("DD")
      };
      if (other == "other") d.other = true;
      if (day.format("YYYYMMDD") == this.today.format("YYYYMMDD"))
        d.today = true;
      this.monthData[weekIndex].push(d);
    }
  }
};
</script>

<style lang="scss">
.component-fade-enter-active {
  transition: all 0.3s ease;
}
.component-fade-leave-active {
  /*transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
}
.component-fade-enter,
.component-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.calendar-css,
.calendar-css *,
.calendar-css *:before,
.calendar-css *:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.calendar-css {
  overflow: hidden;
  font-weight: 100;
  color: rgba(77, 77, 77, 1);
  margin: 0;
  padding: 0;
  background: #fff; /*#4a4a4a;*/
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.calendar-css {
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  width: 90%;
  margin: 0 auto;
  /*height: 620px;*/
  height: auto;
  overflow: hidden;

  .header {
    height: 50px;
    width: 100%;
    /*background: rgba(66, 66, 66, 1);*/
    background: rgba(255, 255, 255, 1);
    text-align: center;
    position: relative;
    z-index: 100;
  }

  .header h1 {
    margin: 0;
    padding: 0;
    font-size: 20px;
    line-height: 50px;
    font-weight: 100;
    letter-spacing: 1px;
    /*color: white;*/
    color: #4a4a4a;
  }

  .left,
  .right {
    position: absolute;
    width: 0px;
    height: 0px;
    border-style: solid;
    top: 50%;
    margin-top: -7.5px;
    cursor: pointer;
  }

  .left {
    border-width: 7.5px 10px 7.5px 0;
    border-color: transparent rgba(160, 159, 160, 1) transparent transparent;
    left: 20px;
  }

  .right {
    border-width: 7.5px 0 7.5px 10px;
    border-color: transparent transparent transparent rgba(160, 159, 160, 1);
    right: 20px;
  }

  .month {
    /*overflow: hidden;*/
    /*opacity: 0;*/
  }

  .month.new {
    -webkit-animation: fadeIn 1s ease-out;
    opacity: 1;
  }

  .month.in.next {
    -webkit-animation: moveFromTopFadeMonth 0.4s ease-out;
    -moz-animation: moveFromTopFadeMonth 0.4s ease-out;
    animation: moveFromTopFadeMonth 0.4s ease-out;
    opacity: 1;
  }

  .month.out.next {
    -webkit-animation: moveToTopFadeMonth 0.4s ease-in;
    -moz-animation: moveToTopFadeMonth 0.4s ease-in;
    animation: moveToTopFadeMonth 0.4s ease-in;
    opacity: 1;
  }

  .month.in.prev {
    -webkit-animation: moveFromBottomFadeMonth 0.4s ease-out;
    -moz-animation: moveFromBottomFadeMonth 0.4s ease-out;
    animation: moveFromBottomFadeMonth 0.4s ease-out;
    opacity: 1;
  }

  .month.out.prev {
    -webkit-animation: moveToBottomFadeMonth 0.4s ease-in;
    -moz-animation: moveToBottomFadeMonth 0.4s ease-in;
    animation: moveToBottomFadeMonth 0.4s ease-in;
    opacity: 1;
  }

  .week {
    /*background: #4a4a4a;*/
    background: #fff;
  }

  .day {
    display: inline-block;
    width: 14%;
    padding: 10px;
    text-align: center;
    vertical-align: top;
    cursor: pointer;
    /* background: #4a4a4a; */
    position: relative;
    z-index: 100;
  }

  .day.other {
    /*color: rgba(255, 255, 255, 0.3);*/
    color: rgba(66, 66, 66, 0.3);
  }

  .day.today {
    /*color: rgba(156, 202, 235, 1);*/
    color: rgba(43, 141, 212, 1);
  }

  .day-name {
    font-size: 9px;
    text-transform: uppercase;
    margin-bottom: 5px;
    /*color: rgba(255, 255, 255, 0.5);*/
    color: rgba(33, 33, 33, 0.5);
    letter-spacing: 0.7px;
  }

  .day-number {
    font-size: 24px;
    letter-spacing: 1.5px;
  }

  .day .day-events {
    list-style: none;
    margin-top: 3px;
    text-align: center;
    height: 12px;
    line-height: 6px;
    overflow: hidden;
  }

  .day .day-events span {
    vertical-align: top;
    display: inline-block;
    padding: 0;
    margin: 0;
    width: 80%;
    height: 25px;
    margin: 0 2px;
    font-size: 0.6em;
    color: white;
    /*color: #333;*/
    line-height: 12px;
    font-weight: 900;
  }

  .blue {
    background: rgba(156, 202, 235, 1);
  }
  .orange {
    background: rgba(247, 167, 0, 1);
  }
  .green {
    background: rgba(153, 198, 109, 1);
  }
  .yellow {
    background: rgba(65, 119, 246, 1);
  }

  .details {
    position: relative;
    width: 420px;
    height: 75px;
    background: rgba(164, 164, 164, 1);
    margin-top: 5px;
    border-radius: 4px;
  }

  .details.in {
    -webkit-animation: moveFromTopFade 0.5s ease both;
    -moz-animation: moveFromTopFade 0.5s ease both;
    animation: moveFromTopFade 0.5s ease both;
  }

  .details.out {
    -webkit-animation: moveToTopFade 0.5s ease both;
    -moz-animation: moveToTopFade 0.5s ease both;
    animation: moveToTopFade 0.5s ease both;
  }

  .arrow {
    position: absolute;
    top: -5px;
    left: 50%;
    margin-left: -2px;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 5px 5px 5px;
    border-color: transparent transparent rgba(164, 164, 164, 1) transparent;
    transition: all 0.7s ease;
  }

  .events {
    height: 75px;
    padding: 7px 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .events.in {
    -webkit-animation: fadeIn 0.3s ease both;
    -moz-animation: fadeIn 0.3s ease both;
    animation: fadeIn 0.3s ease both;
  }

  .events.in {
    -webkit-animation-delay: 0.3s;
    -moz-animation-delay: 0.3s;
    animation-delay: 0.3s;
  }

  .details.out .events {
    -webkit-animation: fadeOutShrink 0.4s ease both;
    -moz-animation: fadeOutShink 0.4s ease both;
    animation: fadeOutShink 0.4s ease both;
  }

  .events.out {
    -webkit-animation: fadeOut 0.3s ease both;
    -moz-animation: fadeOut 0.3s ease both;
    animation: fadeOut 0.3s ease both;
  }

  .event {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.5px;
    padding: 2px 16px;
    vertical-align: top;
  }

  .event.empty {
    color: #eee;
  }

  .event-category {
    height: 10px;
    width: 10px;
    display: inline-block;
    margin: 6px 0 0;
    vertical-align: top;
  }

  .event span {
    display: inline-block;
    padding: 0 0 0 7px;
  }

  .legend {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 30px;
    background: rgba(60, 60, 60, 1);
    line-height: 30px;
  }

  .entry {
    position: relative;
    padding: 0 0 0 25px;
    font-size: 13px;
    display: inline-block;
    line-height: 30px;
    background: transparent;
  }

  .entry:after {
    position: absolute;
    content: "";
    height: 5px;
    width: 5px;
    top: 12px;
    left: 14px;
  }

  .entry.blue:after {
    background: rgba(156, 202, 235, 1);
  }
  .entry.orange:after {
    background: rgba(247, 167, 0, 1);
  }
  .entry.green:after {
    background: rgba(153, 198, 109, 1);
  }
  .entry.yellow:after {
    background: rgba(249, 233, 0, 1);
  }

  /* Animations are cool!  */
  @-webkit-keyframes moveFromTopFade {
    from {
      opacity: 0.3;
      height: 0px;
      margin-top: 0px;
      -webkit-transform: translateY(-100%);
    }
  }
  @-moz-keyframes moveFromTopFade {
    from {
      height: 0px;
      margin-top: 0px;
      -moz-transform: translateY(-100%);
    }
  }
  @keyframes moveFromTopFade {
    from {
      height: 0px;
      margin-top: 0px;
      transform: translateY(-100%);
    }
  }

  @-webkit-keyframes moveToTopFade {
    to {
      opacity: 0.3;
      height: 0px;
      margin-top: 0px;
      opacity: 0.3;
      -webkit-transform: translateY(-100%);
    }
  }
  @-moz-keyframes moveToTopFade {
    to {
      height: 0px;
      -moz-transform: translateY(-100%);
    }
  }
  @keyframes moveToTopFade {
    to {
      height: 0px;
      transform: translateY(-100%);
    }
  }
}

@-webkit-keyframes moveToTopFadeMonth {
  to {
    opacity: 0;
    -webkit-transform: translateY(-30%) scale(0.95);
  }
}
@-moz-keyframes moveToTopFadeMonth {
  to {
    opacity: 0;
    -moz-transform: translateY(-30%);
  }
}
@keyframes moveToTopFadeMonth {
  to {
    opacity: 0;
    -moz-transform: translateY(-30%);
  }
}

@-webkit-keyframes moveFromTopFadeMonth {
  from {
    opacity: 0;
    -webkit-transform: translateY(30%) scale(0.95);
  }
}
@-moz-keyframes moveFromTopFadeMonth {
  from {
    opacity: 0;
    -moz-transform: translateY(30%);
  }
}
@keyframes moveFromTopFadeMonth {
  from {
    opacity: 0;
    -moz-transform: translateY(30%);
  }
}

@-webkit-keyframes moveToBottomFadeMonth {
  to {
    opacity: 0;
    -webkit-transform: translateY(30%) scale(0.95);
  }
}
@-moz-keyframes moveToBottomFadeMonth {
  to {
    opacity: 0;
    -webkit-transform: translateY(30%);
  }
}
@keyframes moveToBottomFadeMonth {
  to {
    opacity: 0;
    -webkit-transform: translateY(30%);
  }
}

@-webkit-keyframes moveFromBottomFadeMonth {
  from {
    opacity: 0;
    -webkit-transform: translateY(-30%) scale(0.95);
  }
}
@-moz-keyframes moveFromBottomFadeMonth {
  from {
    opacity: 0;
    -webkit-transform: translateY(-30%);
  }
}
@keyframes moveFromBottomFadeMonth {
  from {
    opacity: 0;
    -webkit-transform: translateY(-30%);
  }
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
}

@-webkit-keyframes fadeOut {
  to {
    opacity: 0;
  }
}
@-moz-keyframes fadeOut {
  to {
    opacity: 0;
  }
}
@keyframes fadeOut {
  to {
    opacity: 0;
  }
}

@-webkit-keyframes fadeOutShink {
  to {
    opacity: 0;
    padding: 0px;
    height: 0px;
  }
}
@-moz-keyframes fadeOutShink {
  to {
    opacity: 0;
    padding: 0px;
    height: 0px;
  }
}
@keyframes fadeOutShink {
  to {
    opacity: 0;
    padding: 0px;
    height: 0px;
  }
}
</style>